
export const setMac = mac => dispatch => {
    dispatch({
      type: 'SET_MAC',
      payload: mac,
    });
  };